import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'round',
})
export class RoundPipe implements PipeTransform {
  transform(value: unknown, decimal = 2): unknown {
    if (typeof value === 'number') {
      return (Math.round((value + Number.EPSILON) * 1000) / 1000).toFixed(decimal); // Round to two decimals
    }
    return value;
  }
}
